import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-card-content" }
const _hoisted_2 = { class: "nav-links p-0 mt-0 list-unstyled" }
const _hoisted_3 = { class: "d-inline-block" }
const _hoisted_4 = { class: "d-inline-block" }
const _hoisted_5 = { class: "d-inline-block" }
const _hoisted_6 = { class: "d-inline-block" }
const _hoisted_7 = { class: "d-inline-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AccountDetails = _resolveComponent("AccountDetails")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "settings-card trezo-card border-radius d-block bg-white border-0 shadow-none" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_RouterLink, { to: "/settings/account-settings" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Account Settings ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_RouterLink, { to: "/settings/change-password" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Change Password ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_RouterLink, { to: "/settings/connections" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Connections ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_RouterLink, { to: "/settings/privacy-policy" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Privacy Policy ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_RouterLink, { to: "/terms-conditions" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Terms & Conditions ", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_AccountDetails)
      ])
    ]),
    _: 1
  }))
}